// Compiled at 2026-05-13T13:50:05.286Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Llama, Llama as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest } from "rxjs";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
    expense: This.Expense;
    projectsOptions: This.Project[];
    chargeabilitiesOptions: { id: boolean, label: string }[];
    isImageFullscreen: boolean;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Llama-ExpenseCardInclude',
    templateUrl: './ExpenseCardInclude.html',
    styleUrls: ['./ExpenseCardInclude.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ExpenseCardInclude extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Llama.ExpenseCardInclude';
    $isDialog = false;
    $Modules = $Modules;
    Llama = Llama;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    @Output()
    onVerified = new EventEmitter<string>();
    output = {
        onVerified: async (data: string) => {
            data = (data as any)?.$clone ? (data as any).$clone() : data
            let result: any

            this.onVerified.emit(data)
            if (this.dialogData?.closeOnOutput === 'onVerified') { this.dialogRef?.close(data) }
            return result
        },
    };
    $validators: Record<number, ValidationRules> = {
        71: {
            sync: [($value: any, $scope: any) => {
                const { app, screen, $pathSegments, $disabled, form } = $scope

                if ($value?.[BoInfoSymbol]?.boType == 'StaticEntity') {
                    if ($value.id) return undefined
                } else {
                    if ($value) return undefined
                    if ($value == 0) return undefined
                }
                return {
                    error: Common.$T.validationRequired,
                    ruleId: 'isRequired',
                }

            }],
            async: [],
        },
        15: {
            sync: [($value: any, $scope: any) => {
                const { app, screen, $pathSegments, $disabled, form } = $scope

                if ($value?.[BoInfoSymbol]?.boType == 'StaticEntity') {
                    if ($value.id) return undefined
                } else {
                    if ($value) return undefined
                    if ($value == 0) return undefined
                }
                return {
                    error: Common.$T.validationRequired,
                    ruleId: 'isRequired',
                }

            }],
            async: [],
        },
        76: {
            sync: [($value: any, $scope: any) => {
                const { app, screen, $pathSegments, $disabled, form } = $scope

                if ($value?.[BoInfoSymbol]?.boType == 'StaticEntity') {
                    if ($value.id) return undefined
                } else {
                    if ($value) return undefined
                    if ($value == 0) return undefined
                }
                return {
                    error: Common.$T.validationRequired,
                    ruleId: 'isRequired',
                }

            }],
            async: [],
        },
        77: {
            sync: [($value: any, $scope: any) => {
                const { app, screen, $pathSegments, $disabled, form } = $scope

                if ($value?.[BoInfoSymbol]?.boType == 'StaticEntity') {
                    if ($value.id) return undefined
                } else {
                    if ($value) return undefined
                    if ($value == 0) return undefined
                }
                return {
                    error: Common.$T.validationRequired,
                    ruleId: 'isRequired',
                }

            }],
            async: [],
        },
        78: {
            sync: [($value: any, $scope: any) => {
                const { app, screen, $pathSegments, $disabled, form } = $scope

                if ($value?.[BoInfoSymbol]?.boType == 'StaticEntity') {
                    if ($value.id) return undefined
                } else {
                    if ($value) return undefined
                    if ($value == 0) return undefined
                }
                return {
                    error: Common.$T.validationRequired,
                    ruleId: 'isRequired',
                }

            }],
            async: [],
        },
        79: {
            sync: [($value: any, $scope: any) => {
                const { app, screen, $pathSegments, $disabled, form } = $scope

                if ($value?.[BoInfoSymbol]?.boType == 'StaticEntity') {
                    if ($value.id) return undefined
                } else {
                    if ($value) return undefined
                    if ($value == 0) return undefined
                }
                return {
                    error: Common.$T.validationRequired,
                    ruleId: 'isRequired',
                }

            }],
            async: [],
        },
        80: {
            sync: [($value: any, $scope: any) => {
                const { app, screen, $pathSegments, $disabled, form } = $scope

                if ($value?.[BoInfoSymbol]?.boType == 'StaticEntity') {
                    if ($value.id) return undefined
                } else {
                    if ($value) return undefined
                    if ($value == 0) return undefined
                }
                return {
                    error: Common.$T.validationRequired,
                    ruleId: 'isRequired',
                }

            }],
            async: [],
        },
        55: {
            sync: [($value: any, $scope: any) => {
                const { app, screen, $pathSegments, $disabled, form } = $scope

                if ($value?.[BoInfoSymbol]?.boType == 'StaticEntity') {
                    if ($value.id) return undefined
                } else {
                    if ($value) return undefined
                    if ($value == 0) return undefined
                }
                return {
                    error: Common.$T.validationRequired,
                    ruleId: 'isRequired',
                }

            }],
            async: [],
        },
        56: {
            sync: [($value: any, $scope: any) => {
                const { app, screen, $pathSegments, $disabled, form } = $scope

                if ($value?.[BoInfoSymbol]?.boType == 'StaticEntity') {
                    if ($value.id) return undefined
                } else {
                    if ($value) return undefined
                    if ($value == 0) return undefined
                }
                return {
                    error: Common.$T.validationRequired,
                    ruleId: 'isRequired',
                }

            }],
            async: [],
        },
        57: {
            sync: [($value: any, $scope: any) => {
                const { app, screen, $pathSegments, $disabled, form } = $scope

                if ($value?.[BoInfoSymbol]?.boType == 'StaticEntity') {
                    if ($value.id) return undefined
                } else {
                    if ($value) return undefined
                    if ($value == 0) return undefined
                }
                return {
                    error: Common.$T.validationRequired,
                    ruleId: 'isRequired',
                }

            }],
            async: [],
        }
    };
    input_expense = input(undefined, { alias: 'expense' });
    var_expense = proxySignal<This.Expense>(undefined as any);
    input_projectsOptions = input(undefined, { alias: 'projectsOptions' });
    var_projectsOptions = proxySignal<This.Project[]>(undefined as any);
    var_chargeabilitiesOptions = proxySignal<{ id: boolean, label: string }[]>(undefined as any);
    var_isImageFullscreen = proxySignal<boolean>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get expense() { return component.var_expense() },
                set expense(value: This.Expense) { component.var_expense.set(value) },
                get projectsOptions() { return component.var_projectsOptions() },
                set projectsOptions(value: This.Project[]) { component.var_projectsOptions.set(value) },
                get chargeabilitiesOptions() { return component.var_chargeabilitiesOptions() },
                set chargeabilitiesOptions(value: { id: boolean, label: string }[]) { component.var_chargeabilitiesOptions.set(value) },
                get isImageFullscreen() { return component.var_isImageFullscreen() },
                set isImageFullscreen(value: boolean) { component.var_isImageFullscreen.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {
            expense: this.screen.expense,
            projectsOptions: this.screen.projectsOptions
        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            const new_expense = this.dialogData?.data?.expense ?? this.input_expense() ?? (null)
            if (new_expense !== undefined) this.screen.expense = new_expense


            const new_projectsOptions = this.dialogData?.data?.projectsOptions ?? this.input_projectsOptions() ?? ([])
            if (new_projectsOptions !== undefined) this.screen.projectsOptions = new_projectsOptions

            if (!isVariablesInitialized) this.screen.chargeabilitiesOptions = ([])
            if (!isVariablesInitialized) this.screen.isImageFullscreen = (false)
            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })

    }

    async handler_ButtonBlock_21_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { form }: { form: Sys.Types.Form } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    await This.ReceiptHelper.verifyExpense(screen.expense)
                    output.onVerified(screen.expense.id)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            screen.chargeabilitiesOptions = [
                { id: true, label: 'Yes' },
                { id: false, label: 'No' },
            ]
        }
    }

    async action_toggleImageFullscreen($event?: any) {
        const { app, screen, output } = this
        {
            screen.isImageFullscreen = !screen.isImageFullscreen
        }
    }
}
